import React from 'react'
import cn from 'classnames'
import { Cell } from 'styled-css-grid'

const Main = ({ className, children }) => (
  <Cell area='main' className={cn('main', className)}>
    {children}
  </Cell>
)
export default Main
